import React from "react";
import "../DesignerPropertiesPanel.css";

const EmptyPropertiesState = () => {
  return (
    <div className="dp-panel">
      <h3 className="dp-title">Properties</h3>
      <p className="dp-empty-text">
        Select an object to edit its properties.
      </p>
    </div>
  );
};

export default EmptyPropertiesState;